export default __webpack_public_path__ + "static/media/navMenu.25dbf265.svg";